import uuid from 'uuid/v1';

export default [
  {
    id: uuid(),
    city:'میبد',
    province: 'یزد',
  },
  {
    id: uuid(),
    city:'تفت',
    province: 'یزد',
  },
  {
    id: uuid(),
    city:'مشهد',
    province: 'خراسان رضوی',
  },
  {
    id: uuid(),
    city:'بیرجند',
    province: 'خراسان جنوبی',
  },
  {
    id: uuid(),
    city:'قشم',
    province: 'بندرعباس',
  },

  
  
];
